import { strapiGetCall } from '../axios';

export const genericContentsUrl = `/gg-generic-content-sections`;
const getGenericContents = (state, params) => {
  return strapiGetCall(state, genericContentsUrl, params);
};

const getSurvey = (state, params) => {
  const url = `/c-360-survey-events`;
  return strapiGetCall(state, url, params);
};

export default { getGenericContents, getSurvey };
